import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { TerraceStorageCalculationVM } from './TerraceStorageCalculationVM';
import { TerraceInputForm } from '../TerraceInputs/TerraceInputs';
import { Row, Col, Container } from 'reactstrap';
import { Accordion } from 'cd-eft/components/common/Accordion';
import './TerraceStorageCalculation.scss';
import { ButtonBlock } from '../../common/ButtonBlock/ButtonBlock';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import stores from 'cd-eft/models/Stores';


const TerraceStorageCalculationComponent = () => {
  const vmREF = useRef<TerraceStorageCalculationVM>();
  if (!vmREF.current) {
    vmREF.current = new TerraceStorageCalculationVM();
  }
  const vm = vmREF.current;
  const { terraceDesignSection, modelOutputsSection } = vm.config;
  const updatedAlignedElementDesignParametersId = Number(stores.AppStore.terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId)
  const terraceType = Number(stores.AppStore.terraceDesignStore.terraceType);

  useEffect(() => {
    if (updatedAlignedElementDesignParametersId > 0 && terraceType > 0) {
      stores.AppStore.terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId = updatedAlignedElementDesignParametersId
      vm.setDefaultInputs();
    }
  }, [updatedAlignedElementDesignParametersId, terraceType])
  return (
    <Container>
      <Row>
        <Col xs="6">
          <Accordion
            className={'storage-calculation-design-container accordion-wrapper'}
            headers={['Terrace Design']}
            waterwayWizardStatus={1}
            light={true}
          >
            <div className='design-calculation-container sub-container'>
              {Object.entries(terraceDesignSection).map(([key, config]) => {
                return (
                  <Row key={'design-calculation-row-' + key}>
                    <Col>
                      <TerraceInputForm
                        key={'design-calculation-input-' + key}
                        config={config}
                        value={vm.inputForms['terraceDesignSection'][key]}
                        onChange={(e) => vm.handleInputsOnChange(e, 'terraceDesignSection')}
                        onBlur={(e) => vm.handleInputsOnBlur(e, 'terraceDesignSection')}
                        red={vm.redHighlighting['terraceDesignSection'][key]}
                      />
                    </Col>
                  </Row>
                )
              })}
              <button className='usa-button sub-calculate-button' disabled={(vm.notGradientType)} onClick={() => vm.onClickCalculate()}>Calculate</button>

            </div>
          </Accordion>
        </Col>
        <Col xs="6">
          <Accordion
            className={'storage-calculation-model-container accordion-wrapper'}
            headers={['Model Outputs']}
            waterwayWizardStatus={1}
            light={true}
          >
            <div className='terrace-model-container sub-container'>
              {Object.entries(modelOutputsSection).map(([key, config]) => (
                <Row key={'terrace-model-row-' + key}>
                  <Col>
                    {vm.hasResults ?
                      <TerraceInputForm
                        key={'terrace-model-' + key}
                        config={config}
                        value={vm.inputForms['modelOutputsSection'][key]}
                        onChange={undefined}
                        onBlur={undefined}
                        red={vm.modelOutputResultsErrors['modelOutputSection'][key]}
                      />
                      : null}
                  </Col>
                </Row>
              ))}
            </div>
          </Accordion>
        </Col>
      </Row>
      <Row className='calculate-buttons-block'>
        <Col>
          <hr />
          <ButtonBlock buttons={vm.buttonsControl} />
        </Col>
      </Row>
      {vm.load && <Loader message={''} />}
    </Container>
  )
};

export const TerraceStorageCalculation = observer(TerraceStorageCalculationComponent);
